import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BottomNav from "../components/BottomNav";
import InternalHeader from "../components/InternalHeader";
import { useAppState } from "../context/AppState";
import { authenticatedApi, authenticatedUpload } from "../lib/api";

function money(value) {
  return `S/ ${Number(value || 0).toFixed(2)}`;
}

export default function WalletPage() {
  const { user } = useAppState();
  const [account, setAccount] = useState(null);
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("YAPE");
  const [reference, setReference] = useState("");
  const [proof, setProof] = useState(null);
  const [busy, setBusy] = useState(Boolean(user));
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  async function loadAccount() {
    if (!user?.auth_token) return;
    setBusy(true);
    try {
      const response = await authenticatedApi("/customer-funds/account", user.auth_token, {
        method: "POST",
        body: "{}",
      });
      setAccount(response.account);
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setBusy(false);
    }
  }

  useEffect(() => {
    loadAccount();
  }, [user]);

  async function requestRecharge(event) {
    event.preventDefault();
    setBusy(true);
    setError("");
    setMessage("");
    try {
      const formData = new FormData();
      formData.append("amount", amount);
      formData.append("method", method);
      formData.append("reference", reference);
      if (proof) formData.append("proof_image", proof);
      const response = await authenticatedUpload(
        "/customer-funds/recharge",
        user.auth_token,
        formData,
      );
      setMessage(response.message);
      setAmount("");
      setReference("");
      setProof(null);
      await loadAccount();
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="food-app">
      <InternalHeader title="Billetera y créditos" backTo="/account" />
      <div className="wallet-page">
        {!user ? (
          <section className="empty-cart">
            <span>🔐</span><h2>Inicia sesión para ver tu saldo</h2>
            <Link to="/account?next=/wallet">Iniciar sesión</Link>
          </section>
        ) : (
          <>
            <section className="wallet-balances">
              <article><small>RECARGAS</small><strong>{money(account?.recharge_balance)}</strong><span>Saldo para pagar pedidos</span></article>
              <article><small>CRÉDITOS DELIVERY</small><strong>{money(account?.balance)}</strong><span>Recompensas para productos; no cubren la tarifa de delivery</span></article>
            </section>
            {account?.rules?.recharge_enabled && (
              <form className="wallet-recharge" onSubmit={requestRecharge}>
                <h2>Solicitar recarga</h2>
                {account.rules.recharge_instructions && <p>{account.rules.recharge_instructions}</p>}
                <div>
                  <label>Monto<input type="number" min={account.rules.recharge_minimum || 5} step="0.01" value={amount} onChange={(event) => setAmount(event.target.value)} required /></label>
                  <label>Método<select value={method} onChange={(event) => setMethod(event.target.value)}><option>YAPE</option><option>PLIN</option><option>BANK</option><option>CASH</option></select></label>
                </div>
                <label>Referencia u operación<input value={reference} onChange={(event) => setReference(event.target.value)} /></label>
                <label>Comprobante<input type="file" accept="image/jpeg,image/png,image/webp" onChange={(event) => setProof(event.target.files?.[0] || null)} /></label>
                <button className="auth-submit" type="submit" disabled={busy}>Enviar para revisión</button>
              </form>
            )}
            {message && <div className="wallet-message">{message}</div>}
            {error && <div className="checkout-error">{error}</div>}
            <section className="wallet-history">
              <h2>Movimientos de créditos</h2>
              {(account?.transactions || []).map((movement) => (
                <article key={movement.id}>
                  <div><b>{movement.description || movement.type}</b><small>{movement.created_at}</small></div>
                  <strong className={Number(movement.amount) < 0 ? "is-negative" : ""}>{Number(movement.amount) > 0 ? "+" : ""}{money(movement.amount)}</strong>
                </article>
              ))}
              {account && account.transactions?.length === 0 && <p>Aún no tienes movimientos.</p>}
            </section>
            <section className="wallet-history">
              <h2>Solicitudes de recarga</h2>
              {(account?.recharges || []).map((recharge) => (
                <article key={recharge.id}>
                  <div><b>{recharge.method} · {recharge.status}</b><small>{recharge.created_at}</small></div>
                  <strong>{money(recharge.amount)}</strong>
                </article>
              ))}
            </section>
          </>
        )}
      </div>
      <BottomNav />
    </main>
  );
}
